const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { getTimelineEndDate, getTimelineStartDate } from '@/components/loop-planner/common/timeline/lib/utils';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getScenarioQueryOptions } from '@/lib/queries/loop-planner/useGetScenario';
import { getTimelineItemsDataSetQueryOptions } from '@/lib/queries/loop-planner/useGetTimelineItemsDataSet';
import { isHttpError } from '@/lib/utils/common/isHttpError';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/')({
  loader: async ({
    params: {
      loopId,
      scenarioId,
      org
    },
    context: {
      queryClient
    }
  }) => {
    try {
      const [scenarioResponse] = await Promise.all([queryClient.ensureQueryData(getScenarioQueryOptions({
        loopId,
        scenarioId
      })), queryClient.ensureQueryData(getTimelineItemsDataSetQueryOptions({
        loopId,
        scenarioId
      }))]);
      return {
        scenarioId,
        timelineStartDate: scenarioResponse.metrics?.timelineStartDate ? getTimelineStartDate(scenarioResponse.metrics.timelineStartDate) : undefined,
        timelineEndDate: scenarioResponse.metrics?.timelineEndDate ? getTimelineEndDate(scenarioResponse.metrics.timelineEndDate) : undefined
      };
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      if (isHttpError(error, 404)) {
        throw redirect({
          to: '/org/$org/loop/$loopId/planner',
          params: {
            org,
            loopId
          }
        });
      }
      throw error;
    }
  },
  validateSearch: zodValidator(itemPanelSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner
});